export default __webpack_public_path__ + "static/video-833794cbcb1945594ee1a8d243bfa500.webm";